module.exports = __webpack_public_path__ + "img/PlusButton.259a2e69.svg";